import { ReactNode } from "react";
import { cn } from "../../ClassName";

interface Props {
  className?: string;
  children?: ReactNode;
  id?: string;
}

export function H3(props: Props) {
  const defaultStyling = {
    "tw-font-serif": true,
    "tw-font-normal": true,
    "tw-tracking-[-.03em]": true,
    "tw-text-[28px]": !props.className?.includes("tw-text-["),
    "tw-text-blue-dark-1": !props.className?.includes("tw-text-"),
  };

  return (
    <h3 className={cn(defaultStyling, props.className)} id={props.id}>
      {props.children}
    </h3>
  );
}
